import React, { useEffect, useState, useCallback } from 'react';
import { useQuery, gql } from '@apollo/client';
import { toast } from 'react-toastify';

import { logger } from 'RootShared/utility/ErrorLogger';
import ToggleButton from 'Components/ToggleButton/ToggleButton';

export const queryGetProfileData = gql`
  query AppGetProfileDataQuery @api(name: root) {
    inventories {
      inventoryType
      shortDescription
      reference
      hasConfirmed
    }
  }
`;

const TabInventory = (props) => {
  let { formik, onSetInventories } = props;

  const { data: dataProfile, refetch: refetchProfileData, error } = useQuery(queryGetProfileData);

  if (error) {
    logger.error(error);
    toast(error.message, {
      type: toast.TYPE.ERROR,
      autoClose: 3000,
      closeButton: true,
      hideProgressBar: false,
    });
  }

  const [inventories, setInventories] = useState([]);

  useEffect(() => {
    refetchProfileData().then((response) => response.data.inventories && setInventories(response.data.inventories));
  }, [refetchProfileData]);

  const handleChangeToggle = useCallback(
    (id, isInventoryChecked) => {
      const updateInventories = inventories.map((item) => {
        if (item.reference === id) {
          return { ...item, hasConfirmed: isInventoryChecked };
        }
        return item;
      });
      formik.handleBlur();
      onSetInventories(updateInventories);
      setInventories(updateInventories);
    },
    [formik, inventories, onSetInventories]
  );

  return (
    <div id="inventory" className="profile-tab" data-testid="profile-inventory">
      <p className="description">
        Here are devices that are attached to you. Please check regularly for any incorrect information. If you are not
        using a device from the list or the inventory number does not match, disable the device.
      </p>

      {dataProfile && (
        <div data-testid="inventory_list">
          {inventories.map((inventory) => (
            <div className="inventory-card" key={inventory.reference}>
              <div>
                <p className="title">{inventory.reference}</p>
                <div>
                  <p className="label">{inventory.inventoryType}</p>
                  <p>{inventory.shortDescription}</p>
                </div>
              </div>
              <div>
                <ToggleButton
                  onToggleChange={(e) => handleChangeToggle(inventory.reference, e)}
                  toggleStatus={inventory.hasConfirmed}
                  inversion={true}
                  extractToggle={true}
                  id={inventory.reference}
                />
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default TabInventory;
